import { useCallback } from 'react';

import { useLogoImage } from '@app/hooks/useLogoImage';
import { FIELD_TYPES, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { SeriesForm } from './SeriesForm';

const formFields = [
  { key: 'logo', type: FIELD_TYPES.IMAGE, message: 'Logo is required' },
  { key: 'name', type: FIELD_TYPES.MULTILINGUAL, message: 'Name is required' },
  { key: 'short_description', type: FIELD_TYPES.MULTILINGUAL, message: 'Short description is required' },
  { key: 'about', type: FIELD_TYPES.MULTILINGUAL, message: 'About field is required' },
];

const nonRequiredFields = [
  { key: 'schedule', emptyValue: '', isMultilingual: true },
  { key: 'focused_topic_ids', emptyValue: [] },
  { key: 'regular_expert_ids', emptyValue: [] },
];

export const CreateSeries = () => {
  const { logoImage, handleChangeImageLogo, transform } = useLogoImage(nonRequiredFields);

  const validate = useCallback(
    (values: GenericObject) => validateFormFields({ fields: formFields, values, image: logoImage }),
    [logoImage]
  );

  return (
    <CreateView resourceSingular="series" validate={validate} transform={transform}>
      <SeriesForm
        seriesThumbnail={logoImage}
        title="CREATE SERIES"
        handleChangeSeriesThumbnail={handleChangeImageLogo}
      />
    </CreateView>
  );
};
